import { render, staticRenderFns } from "./Header1.vue?vue&type=template&id=218b04c4&scoped=true&"
import script from "./Header1.vue?vue&type=script&lang=js&"
export * from "./Header1.vue?vue&type=script&lang=js&"
import style0 from "./Header1.vue?vue&type=style&index=0&id=218b04c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b04c4",
  null
  
)

export default component.exports